export default "/images/vendor/@coreui/icons/svg/flag/cif-ie.svg?b9f679a82f839305b972a4ca2367dd41";